<template>
  <div>
    <CContainer>
      <CCard>
        <CCardHeader>Web Server Settings</CCardHeader>
        <CCardBody>
          <CForm @submit.prevent="saveSettings">
            <!-- Server Name -->
            <CInput
              label="Server name"
              v-model="settings.serverName"
              placeholder="Enter server name"
            />

            <!-- Port -->
            <CInput
              label="Port"
              type="number"
              v-model.number="settings.port"
              placeholder="Enter server port"
            />
            <!-- Save Button -->
            <CButton type="submit" color="info" shape="pill" class="float-right"
              style="margin-top: 1rem;"><CIcon name="cil-save" class="me-2 mr-1"/>Lưu</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CContainer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      settings: {
        serverName: "My Web Server",
        port: 8080,
        enableSSL: false,
      },
    };
  },
  methods: {
    saveSettings() {
      // Logic to save settings, e.g., make an API call or update localStorage
      // console.log("Settings saved:", this.settings);
      alert("Settings saved successfully!");
    },
  },
};
</script>

<style scoped>
/* Apply custom thickness */
svg.c-icon {
  stroke-width: 2; /* Thicker stroke */
}
</style>
